import React from 'react';
import type { KnowledgeBaseDocument, LibrarianIngestResult } from '@/components/knowledge/types';
import DialogsProvider from '@/components/knowledge/dialogs/DialogsProvider';

interface KnowledgeBaseDialogsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  editOpen: boolean;
  setEditOpen: (open: boolean) => void;
  deleteOpen: boolean;
  setDeleteOpen: (open: boolean) => void;
  deleteCount?: number;
  deleteLabel?: string;
  onDeleteKnowledgeBases?: () => Promise<boolean>;
  documentOpen: boolean;
  setDocumentOpen: (open: boolean) => void;
  editDocumentOpen: boolean;
  setEditDocumentOpen: (open: boolean) => void;
  deleteDocumentOpen: boolean;
  setDeleteDocumentOpen: (open: boolean) => void;
  shareDialogOpen: boolean;
  setShareDialogOpen: (open: boolean) => void;
  activeKnowledgeBase: any;
  activeDocument: KnowledgeBaseDocument | null;
  shares: any[];
  sharesLoading: boolean;
  shareEmail: string;
  setShareEmail: (email: string) => void;
  shareAccessLevel: 'View' | 'Edit' | 'Manage';
  setShareAccessLevel: (level: 'View' | 'Edit' | 'Manage') => void;
  fetchKnowledgeBaseDetails: () => Promise<void>;
  fetchKnowledgeBases: () => Promise<void>;
  onCreateKnowledgeBase?: (values: any) => Promise<void>;
  createCategoryLabel?: string | null;
  uploadAfterCreate?: boolean;
  setUploadAfterCreate?: (uploadAfterCreate: boolean) => void;
  onProcessWithLibrarian?: (document: KnowledgeBaseDocument) => Promise<LibrarianIngestResult | null>;
}

const KnowledgeBaseDialogs = (props: KnowledgeBaseDialogsProps) => {
  return <DialogsProvider {...props} />;
};

export default KnowledgeBaseDialogs;
